module.exports = __webpack_public_path__ + "media/images/ifuturhommefemme-ba1486f968946e1999c0e1bf77d2b1d3.png";